import { render, staticRenderFns } from "./BatchOrdersTable.vue?vue&type=template&id=74779795"
import script from "./BatchOrdersTable.vue?vue&type=script&lang=js"
export * from "./BatchOrdersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports